
/*
get the subdirectory of the URL path
usage:
    pathname = app.complion.com/user/profile;

    pathSubDirectorySelector(pathname, 1) --> user
*/
export const pathSubDirectorySelector = (pathname, index = 1) => pathname.split('/')[index];
